import { nameStartsWithCustomerNumber } from '@supply-mover-2-0/shared';

/** The translation function from `useTranslation()`. */
type TranslateFn = (key: string) => string;

/**
 * PD-17381 — an account named the way the storefront shows it beside
 * statements and in the location picker: its customer number in front of
 * the name, "UT-10386 · Tokyo Teriyaki". A customer with many locations under
 * similar names tells them apart by number, which is also the Customer ID on
 * their statement PDF.
 *
 * Returns a plain string (not JSX) so a `<select>` option can use it too.
 * Each part goes through `t()`. A name that already starts with the number
 * is shown once, and a missing name leaves just the number.
 */
export function customerNumberLabel(
	t: TranslateFn,
	customerNumber: string,
	name: string,
): string {
	const number = customerNumber.trim();
	if (number === '') {
		return t(name);
	}
	if (name.trim() === '') {
		return t(number);
	}
	if (nameStartsWithCustomerNumber(name, number)) {
		return t(name);
	}
	return `${t(number)} ${t('·')} ${t(name)}`;
}
